import React, { ReactNode } from 'react';

import cn from 'classnames';

import './CommonDataCard.scss';

type DataCardType = {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
};
export const CommonDataCard = ({ children, className, onClick }: DataCardType) => {
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div className={cn('CommonDataCard', className)} onClick={onClick}>
      {children}
    </div>
  );
};
